import { render, staticRenderFns } from "./header-footer-form-modal.vue?vue&type=template&id=166a3cf9"
import script from "./header-footer-form-modal.vue?vue&type=script&lang=js"
export * from "./header-footer-form-modal.vue?vue&type=script&lang=js"
import style0 from "./header-footer-form-modal.vue?vue&type=style&index=0&id=166a3cf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports